<template>
	<div class="view-school">
		<Modal
			:show="showSchool"
			content_class="col-12 col-md-11 col-lg-9 col-xl-8 confirm-modal"
		>
			<template slot="content" v-if="selected_school">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								{{ selected_school.school_name }}
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showSchool', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="intermediary-box">
									<div class="clearfix">
										<div class="image-box f-l">
											<img
												:src="
													selected_school.school_image_path
														? api.getDomain() +
															'/' +
															selected_school.school_image_path
														: '/img/logo-1.png'
												"
												alt=""
												class="image"
											/>
										</div>
										<div class="name-box f-l">
											<div class="insurance">
												{{
													selected_school.school_name
												}}
											</div>
											<div class="txt">
												{{
													selected_school.school_description
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="tab-box">
									<div class="tab-switch clearfix">
										<div
											class="tab f-l"
											:class="{ active: activeTab == 1 }"
											@click="openTab(1)"
										>
											My Students
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 2 }"
											@click="openTab(2)"
										>
											Notifications
										</div>
									</div>
									<div class="tab-content">
										<div
											class="content-1"
											v-show="activeTab == 1"
										>
											<div v-if="students.length > 0">
												<div
													class="card fee-card"
													v-for="(
														student, m
													) in students"
													:key="m"
													@click="
														viewStudent(student)
													"
												>
													<div class="clearfix">
														<div
															class="f-r status tx-green"
															:class="{
																'tx-yellow':
																	student
																		.student_details
																		.student_status !==
																	'ACTIVE',
															}"
														>
															{{
																student
																	.student_details
																	.student_status ||
																'Active'
															}}
														</div>
													</div>

													<div class="ref">
														{{
															student
																.student_details
																.student_system_ref
														}}
													</div>
													<div class="class">
														{{
															student
																.student_details
																.student_name
														}}
													</div>
													<div class="s-class">
														{{
															student
																.class_details
																.grade_name
														}}
													</div>
												</div>
											</div>
											<div class="white-content" v-else>
												<div class="title">
													No Students Found!
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 2"
										>
											<div v-if="students.length > 0">
												<div class="card">
													<div
														class="notification"
														v-for="(
															notification, i
														) in school_notifications"
														:key="i"
													>
														<div
															class="content-box"
														>
															<div
																class="top clearfix"
															>
																<div
																	class="title f-l"
																>
																	{{
																		notification.subject
																	}}
																</div>
																<div
																	class="date f-r"
																>
																	{{
																		moment(
																			notification.notification_date,
																			'DD/MM/YYYY',
																		).fromNow()
																	}}
																</div>
															</div>
															<div
																class="bottom clearfix"
															>
																<div
																	class="txt"
																	v-html="
																		notification.details
																	"
																></div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="white-content" v-else>
												<div class="title">
													No Notifications Found!
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
	},
	computed: {
		...mapGetters([
			'activeTab',
			'school_details',
			'loading',
			'school_notifications',
			'students',
			'selected_school',
			'showSchool',
		]),
	},
	data() {
		return {
			api,
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['openTab', 'viewStudent']),
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-school {
	.notification {
		padding: 22px 0;
		border-bottom: solid 1px #f5f9fb;
		cursor: pointer;

		.content-box {
			width: calc(100% - 65px);

			.title {
				color: #3d4661;
				font-weight: 600;
				font-size: 16px;
			}
			.txt {
				color: #646f79;
				font-size: 14px;
			}
			.date {
				color: #646f79;
				font-size: 13px;
				font-weight: 600;
			}
		}
	}
}
</style>
